import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=cdb6f454&"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports